export const attendeeStatus = {
  pending: 'Pending',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
  refund_requested: 'Refunded',
  completed_manually: 'Completed Manually',
}

export const attendeeSortinngColumnsNames = {
  createdAt: 'createdAt',
  totalAmount: 'totalAmount',
}

export const attendeeSkiExperience = {
  all: 'All Experience',
  never_ever: 'Never Ever',
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  vibes: 'Just for the Vibes',
}

export const attendeePersona = {
  all: 'All Personas',
  first_time_ever: 'First Time Ever',
  experienced_skier_boarder: 'Experienced Skier Boarder',
  vibes_culture_community: 'Vibes Culture Community',
  sponsors: 'Sponsors',
}
